import { useSelector } from 'react-redux'
import { CustomLink } from '../../../common/CustomLink'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import { COMPONENTS } from '../../../routers/constants'

export const NameCell = ({
  item,
  val,
  rowId,
  isDynamicReport,
  getDataFromRedux,
}) => {
  const allowRedirectLink = useSelector(
    getDataFromRedux(rowId, 'allowRedirectLink'),
  )
  const organizationId = useSelector(getDataFromRedux(rowId, 'ownerId'))
  const ownershipType = useSelector(getDataFromRedux(rowId, 'ownershipType'))

  const active =
    ['Doanh Nghiệp', 'Enterprise'].includes(ownershipType) && allowRedirectLink

  return (
    <CustomLink
      target="_blank"
      to={
        COMPONENTS.companyAnalysis.components.summary.route +
        '?organizationId=' +
        organizationId
      }
      inActive={!active}
    >
      {isDynamicReport ? (
        item.format(val)
      ) : (
        <TextEllipsisStaticLine
          lineClamp={1}
          text={item.format(val)}
          isI18n={false}
          appendStyle={{
            color: active && '#2C73E8',
          }}
        />
      )}
    </CustomLink>
  )
}
